<template>
  <div>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <notifications></notifications>
      <side-bar v-if="!isExternalLink">
        <!--<user-menu></user-menu>-->
        <mobile-menu></mobile-menu>
        <template slot-scope="props" slot="links">
          <template v-if="cajaOnline && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('cajaOnline'),
                icon: 'fa fa-eye',
                path: '/cajas-online',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="informes && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('informes'),
                icon: 'fa fa-chart-bar',
                path: '/informes',
                isRoute: true,
              }"
            >
            </sidebar-item>
          </template>

          <!-- <a class="nav-link disabled">Disabled</a> -->
          <template v-if="pedidosProveedor && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('pedidosProveedor'),
                icon: 'fas fa-tags',
                path: '/pedidos-proveedor',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="gastos && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('gastos'),
                icon: 'fa fa-credit-card',
                path: '/gestion-gastos',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="almacen && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('almacen'),
                icon: 'fas fa-warehouse',
                path: '/almacen',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="configuracion && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('configuracion'),
                icon: 'fa fa-cogs',
                path: '/configuracion',
              }"
            >
            </sidebar-item>
          </template>
          <template v-if="posicionGlobal && !esSelfi">
            <sidebar-item
              :link="{
                name: $t('posicionGlobal'),
                icon: 'fa fa-globe',
                path: '/posicion-global',
              }"
            >
            </sidebar-item>
          </template>
          <!--
          <sidebar-item
            v-if="camaras"
            :link="{ name: $t('camaras'), icon: 'fas fa-camera', path: '/camaras' }"
          ></sidebar-item>
          -->
          <sidebar-item
            v-if="gestionDePersonal && negocioGestionDePersonal && !esSelfi"
            :link="{
              name: $t('gestionDePersonal'),
              icon: 'fas fa-user-clock',
              path: '/calendar',
            }"
          ></sidebar-item>

          <sidebar-item
            v-if="!esSelfi"
            :link="{
              name: $t('soporteOnline'),
              icon: 'fa fa-envelope',
              path: '/soporte-online',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="configuracionCarta && carta && soloRetail && esSelfi"
            :link="{
              name: $t('configuracionCarta'),
              icon: 'fas fa-cogs',
              path: '/configuracion-carta',
            }"
          ></sidebar-item>
          <!--- Manual de insturcción para los usuarios de Selfibar.-->
          <template>
            <sidebar-item
              v-if="esSelfi"
              :link="{
                name: $t('guiaUsuario'),
                icon: 'fas fa-book',
                path: '/guia-usuario',
              }"
            ></sidebar-item>
        </template>
          <sidebar-item
            v-if="carta && soloRetail && !esSelfi"
            :link="{ name: $t('carta'), icon: 'fas fa-shopping-basket' }"
          >
            <sidebar-item
              v-if="gestionPedidos"
              :link="{
                name: $t('gestionDePedidos'),
                icon: 'fas fa-utensils',
                path: '/delivery',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="configuracionCarta"
              :link="{
                name: $t('configuracionCarta'),
                icon: 'fas fa-cogs',
                path: '/configuracion-carta',
              }"
            ></sidebar-item>
          </sidebar-item>

          <!--TODO CAMBIAR EL NOMBRE DEL COMPONENTE PARA IMPORTAR LOS EXCELS -->
          <sidebar-item
            v-if="amorino"
            :link="{
              name: $t('importacionExcels'),
              icon: 'far fa-file-excel',
              path: '/importacion',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="integracion"
            :link="{
              name: $t('integraciones'),
              icon: 'fa-solid fa-circle-nodes',
              path: '/integraciones',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="log"
            :link="{
              name: 'LOG',
              icon: 'fa-solid fa-fingerprint',
              path: '/log',
            }"
          >
          </sidebar-item>
        </template>
      </side-bar>
      <div class="main-panel">
        <top-navbar v-if="!isExternalLink"></top-navbar>

        <dashboard-content @click="toggleSidebar"> </dashboard-content>

        <content-footer></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { Loading } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
  },
  created() {
    // this.loading = Loading.service({text: 'Cargando...'});
    //this.getCamaras();
    this.getConfigIntegracion();
    this.restrictions();
    this.checkGestionPersonal();
    this.getConfigTpvRetail();
    this.checkIsSelfi();
  },

  data() {
    return {
      gestionDePersonal: true,
      negocioGestionDePersonal: false,

      loading: null,

      camaras: true,

      cajaOnline: true,
      informes: true,
      gastos: true,
      almacen: true,
      pedidosProveedor: true,
      configuracion: true,
      posicionGlobal: true,

      //PERMISOS CONFIGURACION

      materiaPrima: true,
      proveedores: true,
      etiquetas: true,
      productos: true,
      categorias: true,
      modificadores: true,
      clientes: true,
      casas: true,
      operarios: true,
      agencias: true,
      formasPago: true,
      configuracionAlmacen: true,
      rangosHorarios: true,

      //PERMISOS INFORMES

      ventasProductos: true,
      ventasTotalProductos: true,
      invitaciones: true,
      ventasCategorias: true,
      costeProductos: true,
      historicoProductos: true,

      gastosCasas: true,
      gastosCasa: true,

      gastosProveedoresUnidos: true,
      gastosProveedor: true,
      gastosEtiquetas: true,
      gastosMateriaPrima: true,

      ventasNegocios: true,
      ventasComensales: true,
      facturasSimplificadas: true,
      facturasNominativas: true,
      infoformasPago: true,
      infoagencias: true,
      cuentasAparcadas: true,
      cierreCaja: true,
      ventasZonaHoraria: true,
      cuentasAnuladas: true,
      ventasClientes: true,
      ventasOperarios: true,
      turnosOperarios: true,

      //PERMISOS CARTA
      gestionPedidos: true,
      productosCarta: true,
      categoriasCarta: true,
      formasPagoCarta: true,
      negocioCarta: true,
      carta: true,
      configuracionCarta: true,

      amorino: false,
      //Retail
      soloRetail: true,
      //Integraciones
      integracion: false,
      //Log
      log: false,
      esSelfi: false,
    };
  },
  computed: {
    isExternalLink() {
      // Devuelve true si estás en la ruta del enlace externo
      return this.$route.name === "turnos-operarios-external-link";
    },
  },
  methods: {
    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    getConfigIntegracion() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: 117,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigByUser", config)
        .then(function(response) {
          if (response.data.result) {
            vm.integracion = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    restrictions() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              switch (response.data.result[i].idRestriction) {
                case "73":
                  vm.log = true;
                  break;
                case "72":
                  vm.integracion = true;
                  //console.log(vm.integraciones);
                  break;
                case 1:
                  vm.cajaOnline = false;
                  break;
                case 52:
                  vm.camaras = false;
                  break;
                case 23:
                  vm.ventasProductos = false;
                  break;
                case 24:
                  vm.ventasTotalProductos = false;
                  break;
                case 25:
                  vm.invitaciones = false;
                  break;
                case 26:
                  vm.ventasCategorias = false;
                  break;
                case 27:
                  vm.costeProductos = false;
                  break;
                case 45:
                  vm.historicoProductos = false;
                  break;
                case 28:
                  vm.gastosCasas = false;
                  break;
                case 29:
                  vm.gastosCasa = false;
                  break;
                case 30:
                  vm.gastosProveedoresUnidos = false;
                  break;
                case 31:
                  vm.gastosProveedor = false;
                  break;
                case 32:
                  vm.gastosEtiquetas = false;
                  break;
                case 33:
                  vm.gastosMateriaPrima = false;
                  break;
                case 34:
                  vm.ventasNegocios = false;
                  break;
                case 35:
                  vm.ventasComensales = false;
                  break;
                case 36:
                  vm.facturasSimplificadas = false;
                  break;
                case 37:
                  vm.facturasNominativas = false;
                  break;
                case 38:
                  vm.infoformasPago = false;
                  break;
                case 39:
                  vm.infoagencias = false;
                  break;
                case 40:
                  vm.cuentasAparcadas = false;
                  break;
                case 41:
                  vm.cierreCaja = false;
                  break;
                case 48:
                  vm.ventasZonaHoraria = false;
                  break;
                case 47:
                  vm.cuentasAnuladas = false;
                  break;
                case 42:
                  vm.ventasClientes = false;
                  break;
                case 43:
                  vm.ventasOperarios = false;
                  break;
                case 44:
                  vm.turnosOperarios = false;
                  break;

                case 21:
                  vm.almacen = false;
                  break;

                case 22:
                  vm.pedidosProveedor = false;
                  break;

                case 50:
                  vm.posicionGlobal = false;
                  break;

                case 9:
                  vm.materiaPrima = false;
                  break;

                case 10:
                  vm.proveedores = false;
                  break;

                case 11:
                  vm.etiquetas = false;
                  break;
                case 12:
                  vm.productos = false;
                  break;
                case 13:
                  vm.categorias = false;
                  break;
                case 14:
                  vm.modificadores = false;
                  break;
                case 15:
                  vm.clientes = false;
                  break;
                case 16:
                  vm.casas = false;
                  break;
                case 17:
                  vm.operarios = false;
                  break;
                case 18:
                  vm.agencias = false;
                  break;
                case 19:
                  vm.formasPago = false;
                  break;
                case 49:
                  vm.configuracionAlmacen = false;
                  break;
                case 51:
                  vm.rangosHorarios = false;
                  break;
                case 20:
                  vm.gastos = false;
                  break;

                //PERMISOS CARTA

                case 59:
                  vm.gestionPedidos = false;
                  break;
                case 60:
                  vm.productosCarta = false;
                  break;
                case 61:
                  vm.categoriasCarta = false;
                  break;
                case 62:
                  vm.formasPagoCarta = false;
                  break;
                case 63:
                  vm.negocioCarta = false;
                  break;
                case 64:
                  vm.amorino = true;
                  break;
                case 70:
                  vm.gestionDePersonal = false;
                  break;
              }
            }

            if (
              !vm.materiaPrima &&
              !vm.proveedores &&
              !vm.etiquetas &&
              !vm.productos &&
              !vm.categorias &&
              !vm.modificadores &&
              !vm.clientes &&
              !vm.casas &&
              !vm.operarios &&
              !vm.agencias &&
              !vm.formasPago &&
              !vm.configuracionAlmacen &&
              !vm.rangosHorarios
            ) {
              vm.configuracion = false;
            }

            if (
              !vm.ventasProductos &&
              !vm.ventasTotalProductos &&
              !vm.invitaciones &&
              !vm.ventasCategorias &&
              !vm.costeProductos &&
              !vm.historicoProductos &&
              !vm.gastosCasas &&
              !vm.gastosCasa &&
              !vm.gastosProveedoresUnidos &&
              !vm.gastosProveedor &&
              !vm.gastosEtiquetas &&
              !vm.gastosMateriaPrima &&
              !vm.ventasNegocios &&
              !vm.ventasComensales &&
              !vm.facturasSimplificadas &&
              !vm.facturasNominativas &&
              !vm.infoformasPago &&
              !vm.infoagencias &&
              !vm.cuentasAparcadas &&
              !vm.cierreCaja &&
              !vm.ventasZonaHoraria &&
              !vm.cuentasAnuladas &&
              !vm.ventasClientes &&
              !vm.ventasOperarios &&
              !vm.turnosOperarios
            ) {
              vm.informes = false;
            }

            if (
              !vm.gestionPedidos &&
              !vm.productosCarta &&
              !vm.categoriasCarta &&
              !vm.formasPagoCarta &&
              !vm.negocioCarta
            ) {
              vm.carta = false;
            }

            if (
              !vm.productosCarta &&
              !vm.categoriasCarta &&
              !vm.formasPagoCarta &&
              !vm.negocioCarta
            ) {
              vm.configuracionCarta = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //SI NO TIENE CAMARAS OCULTAMOS LA PESTAÑA
    getCamaras() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getCamaras", config)
        .then(function(response) {
          if (!response.data.response) {
            vm.camaras = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //PARA EJECUTAR
    checkGestionPersonal() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          //1 es gestión de personal
          idLicencia: 1,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkLicenciaProducto",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.negocioGestionDePersonal = response.data.result;
          } else {
            console.error("Ha ocurrido un error al comprobar las licencias");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    restrictionCal() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getUser", config)
        .then(function(response) {
          if (response.data.response) {
            vm.registrosHorarios = true;
          } else {
            vm.registrosHorarios = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getConfigTpvRetail() {
      //Necesita IdBusiness
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 84,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.soloRetail = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">

.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/DashboardLayout.vue